module.exports = __webpack_public_path__ + "ipetbooking-landing/img/illustration03.9bad73b8.svg";